import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';
import * as mailTypes from '@mail/store/types';
// components
import TreeList from './TreeList.vue';

@Component({
    components: { TreeList },

    computed: {
        ...mapGetters({
            folders: mailTypes.FOLDER_LIST,
        }),
    },

    methods: {
        ...mapActions({
            load: mailTypes.FOLDER_LOAD,
        }),
    },
})
export default class FolderList extends Vue {
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    folders!: mail.MailboxFolder[];

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: A C T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    load!: (parentId?: string) => Promise<void>;

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    selectedFolder: mail.MailboxFolder | null = null;

    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: C O M P U T E D : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    get filteredFolders() {
        return this.folders.map((f) => {
            return {
                expanded: false,
                ...f,
                selected: f.selected = this.selectedFolder?.id === f.id,
            };
        });
    }

    get currentFolderId() {
        //return this.current.currentNode.functionId;
        return ''
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    created() {
        this.load();
    }

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    select(folder: mail.MailboxFolder) {
        this.selectedFolder = folder;
        this.$emit('select', folder);
    }

    expand(folder: mail.MailboxFolder) {
        this.load(folder.id);
    }
}
